import React from 'react';
import PropTypes from 'prop-types';
import { reportEvent } from '../helper';
import Seller from './Seller';
import Buyer from './Buyer';

const ProfileBanner = ({
    buyerMessage,
    isPageOwner,
    username,
    openCancelVacationPopup,
    userId,
    allowContact,
    displayName,
    openPopup,
    startDate,
    endDate
}) => {
    const clickContact = () => {
        reportEvent('contact_me.click', {
            'current_page_type': 'seller_page',
            'seller': {
                'id': userId
            }
        }, 'conversation');
    };

    return isPageOwner ? (
        <Seller startDate={startDate}
            endDate={endDate}
            openCancelVacationPopup={openCancelVacationPopup}
            allowContact={allowContact}
            openPopup={openPopup}/>
    ) : (
        <Buyer endDate={endDate}
            buyerMessage={buyerMessage}
            allowContact={allowContact}
            displayName={displayName}
            username={username}
            clickContact={clickContact}/>
    );
};

ProfileBanner.propTypes = {
    allowContact: PropTypes.bool,
    isPageOwner: PropTypes.bool,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    buyerMessage: PropTypes.string,
    username: PropTypes.string,
    openCancelVacationPopup: PropTypes.func,
    displayName: PropTypes.string,
    openPopup: PropTypes.func,
    userId: PropTypes.number
};

ProfileBanner.defaultProps = {
    allowContact: false,
    isPageOwner: false,
    buyerMessage: '',
    startDate: 0,
    endDate: 0
};

export default ProfileBanner;
